import type { ComponentProps } from 'react';
import classnames from 'classnames/bind';
import { isNil } from 'lodash/fp';
import { useModalContext } from 'app/components/core/Modal/ModalContext';
import * as styles from './ModalTitle.css';

const cx = classnames.bind(styles);

export interface Props extends ComponentProps<'h3'> {
    testId?: string;
    className?: string;
}

export function ModalTitle({ testId, className, children, ...props }: Props) {
    const context = useModalContext();

    if (isNil(context)) {
        throw new Error('<ModalTitle> must be used within a <Modal> component.');
    }

    const { titleId } = context;
    const classes = cx('base', className);

    return (
        <h3 id={titleId} data-testid={testId} className={classes} {...props}>
            {children}
        </h3>
    );
}
